export const FETCHED_FOLLOWSHIPS = "FETCHED_FOLLOWSHIPS";
export const CREATED_FOLLOWSHIP = "CREATED_FOLLOWSHIP";
export const DELETED_FOLLOWSHIP = "DELETED_FOLLOWSHIP";
export const RECEIVED_FOLLOWSHIP_ID = "RECEIVED_FOLLOWSHIP_ID";
export const RECEIVED_FOLLOWSHIPS = "RECEIVED_FOLLOWSHIPS";
